
import { ChangeEvent, useState } from "react";
import { Box, Grid,  Typography, Paper, TextField } from "@mui/material";
import { useThemeContextChange } from "../themeContext";

const ColorSelector = () => {
  const {
    headerColor,setHeaderColor, headerTextColor, setHeaderTextColor, headerButtonColor, setHeaderButtonColor,
      headerButtonTextColor, setHeaderButtonTextColor, contentBackgroundColor, setContentBackgroundColor, contentTitleColor, setContentTitleColor,
      contentTextColor, setContentTextColor, contentButtonColor, setContentButtonColor,contentButtonTextColor, setContentButtonTextColor,
      footerBackgroundColor, setFooterBackgroundColor, footerTextColor, setFooterTextColor, footerButtonColor, setFooterButtonColor, footerButtonTextColor, setFooterButtonTextColor
  } = useThemeContextChange();


  const [themeHeaderColor, setThemeHeaderColor] = useState(headerColor);
  const [themeHeaderFontColor, setThemeHeaderFontColor] = useState(headerTextColor);
  const [themeHeaderButtonColor, setThemeHeaderButtonColor] = useState(headerButtonColor);
  const [themeHeaderButtonTextColor, setThemeHeaderButtonTextColor] = useState(headerButtonTextColor);

  const [themeContentBackgroundColor, setThemeContentBackgroundColor] = useState(contentBackgroundColor);
  const [themeContentTitleColor, setThemeContentTitleColor] = useState(contentTitleColor);
  const [themeContentTextColor, setThemeContentTextColor] = useState(contentTextColor);
  const [themeContentButtonColor, setThemeContentButtonColor] = useState(contentButtonColor);
  const [themeContentButtonTextColor, setThemeContentButtonTextColor] = useState(contentButtonTextColor);

  const [themeFooterBackgroundColor, setThemeFooterBackgroundColor] = useState(footerBackgroundColor);
  const [themeFooterTextColor, setThemeFooterTextColor] = useState(footerTextColor);
  const [themeFooterButtonColor, setThemeFooterButtonColor] = useState(footerButtonColor);
  const [themeFooterButtonTextColor, setThemeFooterButtonTextColor] = useState(footerButtonTextColor);
  
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeHeaderColor(event.target.value);
    setHeaderColor(event.target.value);
  };
  const handleHeaderTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeHeaderFontColor(event.target.value);
    setHeaderTextColor(event.target.value);
  };
  const handleHeaderButtonChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeHeaderButtonColor(event.target.value);
    setHeaderButtonColor(event.target.value);
  };
  const handleHeaderButtonTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeHeaderButtonTextColor(event.target.value);
    setHeaderButtonTextColor(event.target.value);
  };

  

  const handleContentBackChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeContentBackgroundColor(event.target.value);
    setContentBackgroundColor(event.target.value);
  };

  const handleContentTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeContentTitleColor(event.target.value);
    setContentTitleColor(event.target.value);
  };
  const handleContentTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeContentTextColor(event.target.value);
    setContentTextColor(event.target.value);
  };
  const handleContentButtonChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeContentButtonColor(event.target.value);
    setContentButtonColor(event.target.value);
  };
  const handleContentButtonTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeContentButtonTextColor(event.target.value);
    setContentButtonTextColor(event.target.value);
  };


  const handleFooterChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeFooterBackgroundColor(event.target.value);
    setFooterBackgroundColor(event.target.value);
  };
  const handleFooterTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeFooterTextColor(event.target.value);
    setFooterTextColor(event.target.value);
  };
  const handleFooterButtonChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeFooterButtonColor(event.target.value);
    setFooterButtonColor(event.target.value);
  };
  const handleFooterButtonTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setThemeFooterButtonTextColor(event.target.value);
    setFooterButtonTextColor(event.target.value);
  };


  return (
    <Grid container spacing={1} className="theme_test">
      {/* Sidebar with color options */}
      <Grid item xs={12} mt={0}>
        <Grid className="custom_colors">
          <Paper elevation={3} sx={{ padding: 2, boxShadow:"none" }}>
            <Typography variant="h6" sx={{ marginBottom: 3 }}>
              Customizing Colors
            </Typography>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Header Section
            </Typography>
            <Grid container>
              <Grid item md={7} xs={8} sm={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeHeaderColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                      boxShadow:"1px 2px 3px  solid #ddd !important"
                    }}
                  />
                  <Typography>Header Background Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField
                  className="theme_text_box"
                  value={themeHeaderColor}
                  onChange={handleChange}
                  
                />
              </Grid>
             
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeHeaderFontColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Header Text Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeHeaderFontColor} 
                  onChange={handleHeaderTextChange}
                  
                  />
              </Grid>
              
            </Grid>

            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeHeaderButtonColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Header Button Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeHeaderButtonColor}
                  onChange={handleHeaderButtonChange}
                  />
              </Grid>
             
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeHeaderButtonTextColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Header Button Text</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeHeaderButtonTextColor} 
                onChange={handleHeaderButtonTextChange}
                />
              </Grid>
              
            </Grid>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Content Section
            </Typography>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeContentBackgroundColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Content Background Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeContentBackgroundColor}
                  onChange={handleContentBackChange}

                />
              </Grid>
             
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeContentTitleColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Content Title Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeContentTitleColor} 
                  onChange={handleContentTitleChange}
                  
                  />
              </Grid>
              
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeContentTextColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Content Text Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeContentTextColor} 
                  onChange={handleContentTextChange}
                  />
              </Grid>
              
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeContentButtonColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Content Button Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeContentButtonColor} 
                  onChange={handleContentButtonChange}
                  />
              </Grid>
              
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeContentButtonTextColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Content Button Text Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeContentButtonTextColor} 
                  onChange={handleContentButtonTextChange}
                  />
              </Grid>
             
            </Grid>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Footer Section
            </Typography>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeFooterBackgroundColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Footer Background Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeFooterBackgroundColor} 
                  onChange={handleFooterChange}

                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeFooterTextColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Footer Text Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeFooterTextColor} 
                  onChange={handleFooterTextChange}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeFooterButtonColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Footer Button Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeFooterButtonColor} 
                  onChange={handleFooterButtonChange}
                  />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={7} xs={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: themeFooterButtonTextColor,
                      borderRadius: 1,
                      marginRight: 2,
                      border:"1px solid #ddd !important",
                    }}
                  />
                  <Typography>Footer Button Text Color</Typography>
                </Box>
              </Grid>
              <Grid item md={4} xs={4}>
                <TextField className="theme_text_box" value={themeFooterButtonTextColor} 
                  onChange={handleFooterButtonTextChange}
                  />
              </Grid>
            </Grid>
          </Paper>
          </Grid>
      </Grid>
    </Grid>
  );
};

export default ColorSelector;

